import { FilterFunction, initAsyncSlice } from 'aa_common/front-end/zustand'
import { DepreciationResultsService, PresenterDepreciationResultsAdjustAdjustmentResponse } from 'common/open-api'

const initFilter: {
  id?: number
} = {}

const initState: PresenterDepreciationResultsAdjustAdjustmentResponse = {}

const fetchData: FilterFunction<typeof initState, typeof initFilter> = async filters => {
  return DepreciationResultsService.depreciationResultsDetail(Number(filters?.id))
}

export const acceleratedEventLogStore = initAsyncSlice<typeof initState, typeof initFilter>(
  'audit-log-detail/depreciation-result-adjustments',
  initState,
  initFilter,
  fetchData
)

export const getAdjustHistory = (id: number) => acceleratedEventLogStore.setFilters({ id }, true)
export const resetAdjustHistory = () => acceleratedEventLogStore.setData(initState)
